module.exports = __webpack_public_path__ + "img/ic-arrow-down.14e6b96d.svg";